const takeTime = [
  { time: '12:00 - 14:30', price: 0, title: 'PLM ☀️' },
  { time: '16:00 - 19:30', price: 0, title: 'PLT🌙' },
]
export default takeTime
